import { createActions } from 'reduxsauce';

export const { Types: types, Creators: actions } = createActions({
    // view user
    requestViewUser: ['id'],
    viewUserSucceeded: ['data'],
    viewUserFailed: ['error'],

    // clear state
    clearUserViewState: null,
});

export default {
    // view user
    [types.REQUEST_VIEW_USER]: (state) => ({
        ...state,
        view: {
            ...state.view,
            loading: true,
            error: null,
        },
    }),
    [types.VIEW_USER_SUCCEEDED]: (state, { data }) => ({
        ...state,
        view: {
            ...state.view,
            userDetails: data,
            loading: false,
        },
    }),
    [types.VIEW_USER_FAILED]: (state, { error }) => ({
        ...state,
        view: {
            ...state.view,
            loading: false,
            error,
        },
    }),

    // clear state
    [types.CLEAR_USER_VIEW_STATE]: (state) => ({
        ...state,
        view: {
            ...state.view,
            userDetails: null,
        },
    }),
}
